module.exports = __webpack_public_path__ + "img/icon_popup_arrow_close.31aea788.svg";